<template>
    <div v-if="visible" class="session-modal-overlay" @click="handleOverlayClick">
        <div class="session-modal-content" @click.stop>
            <!-- 关闭按钮 -->
            <div class="close-button" @click="handleClose">
                <div class="close-circle"></div>
                <div class="close-icon">
                    <img src="../images/close-icon-1.svg" class="close-line" alt="" />
                    <img src="../images/close-icon-2.svg" class="close-line" alt="" />
                </div>
            </div>

            <!-- 弹窗主体 -->
            <div class="modal-body">
                <!-- 标题 -->
                <div class="modal-title">選擇你想參與的場次</div>

                <!-- 副标题 -->
                <div class="modal-subtitle">每人只能報名一場</div>

                <!-- 场次列表 -->
                <div class="session-list">
                    <div
                        v-for="session in sessions"
                        :key="session.sessionId"
                        class="session-item"
                        :class="{
                            selected: selectedSessionId === session.sessionId,
                            disabled: isSessionDisabled(session)
                        }"
                        @click="handleSelectSession(session.sessionId, session)"
                    >
                        <!-- 场次卡片背景 -->
                        <img
                            v-if="selectedSessionId === session.sessionId"
                            src="../images/session-card-selected.svg"
                            class="session-card-bg"
                            alt=""
                        />
                        <img v-else src="../images/session-card-normal.svg" class="session-card-bg" alt="" />

                        <!-- 场次文字 -->
                        <div class="session-text">{{ formatSessionName(session) }}</div>

                        <!-- 选中图标 -->
                        <img
                            v-if="selectedSessionId === session.sessionId"
                            src="../images/check-icon.svg"
                            class="check-icon"
                            alt=""
                        />

                        <!-- 禁用状态标签 -->
                        <div v-if="isSessionDisabled(session)" class="disabled-label">
                            {{ getDisabledReason(session) }}
                        </div>
                    </div>
                </div>

                <!-- 确认按钮 -->
                <div class="confirm-button" :class="{ disabled: !selectedSessionId }" @click="handleConfirm">
                    <div class="confirm-button-text">我選這場</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
import dayjs from 'dayjs';
import { ref } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  sessions: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport
  } = require('@fegobull/webapi').use;
  useTeleport(document.body);
  const props = __props;
  const emit = __ctx.emit;

  // 当前选中的场次ID
  const selectedSessionId = ref(null);

  // 将时间转换为时间戳（秒）
  const toTimestamp = time => {
    if (!time) {
      return null;
    }
    // 如果已经是时间戳（数字类型），直接返回
    if (typeof time === 'number') {
      return time;
    }
    // 如果是字符串，使用 dayjs 解析
    if (typeof time === 'string') {
      return dayjs(time).unix();
    }
    return null;
  };

  // 判断场次是否禁用
  const isSessionDisabled = session => {
    const now = Math.floor(Date.now() / 1000);

    // 判断是否报名时间已过
    const registrationEndTime = toTimestamp(session.registrationEndTime);
    if (registrationEndTime && now > registrationEndTime) {
      return true;
    }

    // 判断是否没有名额
    if (session.remainingCount <= 0) {
      return true;
    }
    return false;
  };

  // 获取禁用原因
  const getDisabledReason = session => {
    const now = Math.floor(Date.now() / 1000);

    // 优先显示报名已截止
    const registrationEndTime = toTimestamp(session.registrationEndTime);
    if (registrationEndTime && now > registrationEndTime) {
      return '已截止';
    }

    // 然后显示名额已满
    if (session.remainingCount <= 0) {
      return '已滿';
    }
    return '';
  };

  // 处理选择场次
  const handleSelectSession = (sessionId, session) => {
    // 如果场次禁用，不允许选择
    if (isSessionDisabled(session)) {
      return;
    }
    selectedSessionId.value = sessionId;
  };

  // 格式化场次名称
  const formatSessionName = session => {
    if (session.sessionName) {
      return session.sessionName;
    }
    if (session.sessionTime) {
      const date = dayjs.unix(session.sessionTime);
      const month = date.month() + 1;
      const day = date.date();
      const timeOfDay = date.hour() < 12 ? '上午場' : '下午場';
      return `${month}月${day}日 ${timeOfDay}`;
    }
    return '未知場次';
  };

  // 处理关闭
  const handleClose = () => {
    selectedSessionId.value = null;
    emit('close');
  };

  // 处理遮罩层点击
  const handleOverlayClick = () => {
    handleClose();
  };

  // 处理确认
  const handleConfirm = () => {
    if (!selectedSessionId.value) {
      return;
    }
    const selectedSession = props.sessions.find(s => s.sessionId === selectedSessionId.value);
    if (selectedSession) {
      emit('confirm', selectedSession);
      selectedSessionId.value = null;
    }
  };
  return {
    selectedSessionId,
    isSessionDisabled,
    getDisabledReason,
    handleSelectSession,
    formatSessionName,
    handleClose,
    handleOverlayClick,
    handleConfirm
  };
};
export default __sfc_main;
</script>

<style scoped lang="less">
// 遮罩层
// layout_XTZDJ3, fill_N1YY3O
.session-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(175, 175, 175, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

// 弹窗内容容器
.session-modal-content {
    position: relative;
    width: 5.8rem;
    background: transparent;
}

// 关闭按钮
// layout_LXW4JM
.close-button {
    position: absolute;
    bottom: -0.8rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0.5rem;
    height: 0.48rem;
    cursor: pointer;
    z-index: 10;

    // layout_DIXYZH, fill_HMAHLA, stroke_IO45K6
    .close-circle {
        position: absolute;
        top: 0;
        left: 0;
        width: 0.5rem;
        height: 0.48rem;
        background: rgba(255, 255, 255, 0.15);
        border: 0.015rem solid #ffffff;
        border-radius: 50%;
    }

    // layout_BEGCI3
    .close-icon {
        position: absolute;
        left: 0.1875rem;
        top: 0.18rem;
        width: 0.125rem;
        height: 0.12rem;

        .close-line {
            position: absolute;
            top: 0;
            left: 0;
            width: 0.125rem;
            height: 0.12rem;
        }
    }
}

// 弹窗主体
// layout_921ZY9, fill_C2NWJL
.modal-body {
    position: relative;
    width: 5.8rem;
    min-height: 7.14rem;
    max-height: 90vh;
    background: #ffffff;
    border-radius: 0.4rem;
    padding: 0.4rem 0 0.4rem 0;
    display: flex;
    flex-direction: column;
}

// 标题
// layout_MTBGE7, style_HR6MGH, fill_29J4G0
.modal-title {
    position: absolute;
    left: 0.5rem;
    top: 0.4rem;
    width: 4.8rem;
    height: 0.65rem;
    font-family: FZLanTingHei-M-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.42rem;
    line-height: 1.5476em;
    text-align: center;
    color: #000000;
}

// 副标题
// layout_Y2306C, style_JHO40F, fill_RGRDJG
.modal-subtitle {
    position: absolute;
    left: 1.38rem;
    top: 1.09rem;
    width: 3.04rem;
    height: 0.28rem;
    font-family: FZLanTingHei-R-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.28rem;
    line-height: 1em;
    text-align: center;
    color: #7a7a7a;
}

// 场次列表
.session-list {
    position: absolute;
    left: 0.9rem;
    top: 1.65rem;
    right: 0.9rem;
    bottom: 1.48rem;
    width: 4.0083rem;
    display: flex;
    flex-direction: column;
    gap: 0.0976rem;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 0.2rem;

    &::-webkit-scrollbar {
        width: 0.04rem;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 0.02rem;
    }
}

// 场次项
.session-item {
    position: relative;
    width: 4.0083rem;
    height: 0.8307rem;
    cursor: pointer;
    flex-shrink: 0;
    transition: transform 0.2s ease;

    &:active {
        transform: scale(0.98);
    }

    // 禁用状态
    &.disabled {
        cursor: not-allowed;
        opacity: 0.5;

        &:active {
            transform: none;
        }

        .session-card-bg {
            filter: grayscale(100%);
        }

        .session-text {
            color: #999999;
        }
    }

    // layout_SDLCOB
    .session-card-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 4.0083rem;
        height: 0.8307rem;
        border-radius: 0.12rem;
    }

    // layout_Z1MQQE, layout_TABC5K, layout_1A06RJ, layout_Y9LGJI
    // style_IS9D93, fill_8I8ZFR
    .session-text {
        position: absolute;
        left: 0.1769rem;
        top: 0.2474rem;
        width: 1.99rem;
        height: 0.3167rem;
        font-family: FZLanTingHei-R-GBK, sans-serif;
        font-weight: 400;
        font-size: 0.28rem;
        line-height: 1.1445em;
        text-align: center;
        color: #494949;
    }

    // layout_MPTDT3, stroke_Q8Y8CC
    .check-icon {
        position: absolute;
        right: 0.37rem;
        top: 0.2771rem;
        width: 0.22rem;
        height: 0.2276rem;
    }

    // 禁用状态标签
    .disabled-label {
        position: absolute;
        right: 0.3rem;
        top: 50%;
        transform: translateY(-50%);
        padding: 0.05rem 0.15rem;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 0.04rem;
        font-family: FZLanTingHei-R-GBK, sans-serif;
        font-weight: 400;
        font-size: 0.24rem;
        line-height: 1.2em;
        color: #ffffff;
        white-space: nowrap;
    }
}

// 确认按钮
// layout_T13KNV, fill_5DVOQO
.confirm-button {
    position: absolute;
    left: 0.9rem;
    bottom: 0.4rem;
    width: 4rem;
    height: 0.88rem;
    background: #ff6900;
    border-radius: 0.44rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: none;
    }

    // layout_81AZSW, style_SXLBA9, fill_C2NWJL
    .confirm-button-text {
        font-family: FZLanTingHei-M-GBK, sans-serif;
        font-weight: 400;
        font-size: 0.32rem;
        line-height: 0.625em;
        text-align: center;
        color: #ffffff;
    }
}
</style>
